<template>
  <div class="NewsList">
    <v-window v-model="indexOfPage">
      <v-window-item v-for="(page, col) in pages" :key="col">
        <div class="news-area" v-for="(news, row) in page" :key="row" @click="onNews(col, row)">
          <news-list-item
            :title="news.title"
            :start-date="news.startDate"
            :end-date="news.endDate"
            :img-flg="news.imgFlg"
            :image-path="news.imgPath"
            :is-new="isNew(news.startDate)"
          ></news-list-item>
        </div>
      </v-window-item>
    </v-window>
    <pager v-if="pages.length > 1" v-model="indexOfPage" :count="pages.length"></pager>
  </div>
</template>

<script>
import NewsListItem from "../components/NewsListItem";
import Pager from "../components/Pager";
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen'
import { splitArray } from "../assets/js/util";

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "NewsList",
  components: {
    NewsListItem,
    Pager
  },
  mixins: [Protobuf, Screen],
  data() {
    return {
      tab: 1,
      categoryList: [],
      newsList: [],
      indexOfPage: 0
    }
  },
  computed: {
    pages() {
      return splitArray(this.filterNews(), 10)
    }
  },
  methods: {
    isNew(startdate) {
      const n = 1
      const date = new Date()
      date.setDate(date.getDate() - n)
      return new Date(startdate * 1000) > date
    },
    filterNews() {
      let result = []
      result = this.newsList.filter(news => news.category && news.category.id === this.tab)
      result.sort((a, b) => {
        if(b.startDate !== a.startDate)return b.startDate - a.startDate
        return a.id - b.id
      })
      return result
    },
    onNews(col, row) {
      const news = this.filterNews()[col*10+row]
      this.$router.push({ name: 'appnewsDetail', params: { id: news.id } })
    }
  },
  mounted() {
    if(this.$route.query.tab) {
      this.tab = parseInt(this.$route.query.tab)
    }
    this.$nextTick(() => {
      const cmdNo = pb.NewsListReq.CommandNo.COMMAND_NO
      const message = pb.NewsListReq.create({
        type: 1,
      })
      const encoded = pb.NewsListReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status !== pb.NewsListResp.Status.SUCCESS) {
            this.$_error('Error', { title: 'お知らせ一覧', statusCode: 400 })
            return
          }
          if (decoded.newsList.length === 0) {
            this.$_error('Error', { title: 'お知らせ一覧', statusCode: 461 })
            return
          }
          this.newsList = decoded.newsList
          for(let news of decoded.newsList) {
            if(!news.category) continue
            const found = this.categoryList.some(el => el.id === news.category.id)
            if(!found) this.categoryList.push({
              id: news.category.id,
              name: news.category.name
            })
            this.categoryList.sort((a, b) => {return a.id - b.id})
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'お知らせ一覧', statusCode: 100 })
        })
    })
  }
}
</script>

<style lang="scss" scoped>
.NewsList {
  margin-top: -45px;
  min-height: 1000px;
}
</style>
